export const newOriginBlock = {
  id: '',
  title: '',
  link: '',
  description: '',
  isCommon: false,
  editable: true,
  hasBottomBorder: true,
  contactsType: '',
  contactsName: '',
  parentBlockId: null,
};
